import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PersonIcon from '@mui/icons-material/Person';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import PassengerDocument from 'components/PassengerDocument';

import { PassengerDocuments_slot$key } from '__generated__/PassengerDocuments_slot.graphql';

type Props = {
  slot: PassengerDocuments_slot$key;
};

const PassengerDocuments = ({ slot }: Props) => {
  const { passenger, documents } = useFragment(
    graphql`
      fragment PassengerDocuments_slot on PassengerSlot {
        passenger {
          fullName
        }

        documents {
          id
          ...PassengerDocument_document
        }
      }
    `,
    slot
  );

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Avatar sx={{ mr: 1 }}>
          <PersonIcon />
        </Avatar>

        <Box>
          <Typography variant="h6">{passenger?.fullName}</Typography>
        </Box>
      </Box>

      <Grid container spacing={1}>
        {documents.map((document, i) => (
          <Grid item key={document.id} xs={12} sm={12} md={12} lg={6} xl={4}>
            <PassengerDocument
              document={document}
              sx={{ mb: 1, height: '100%' }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PassengerDocuments;
